import { Capacitor } from "@capacitor/core";
import {
  IonContent,
  IonHeader,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import closeIcon from "../../../assets/imgs/close.svg";
import { Colors } from "../../Commons/Colors/Colors";
import { useNavigate } from "react-router-dom";
import { playerDummies } from "../../Rankings/data";
import useFirebaseAnalytics from "../../../hooks/useFirabaseAnality";
import Game_manager_icon from "../../../assets/imgs/game_manager.svg";
import Goal_line_back_icon from "../../../assets/imgs/goal-line-back.svg";
import Receiving_back_icon from "../../../assets/imgs/receiving_back.svg";
import Scrambler_icon from "../../../assets/imgs/Scrambler.svg";
import Target_hog_icon from "../../../assets/imgs/target_hog.svg";
import Work_horse_icon from "../../../assets/imgs/work_horse.svg";
import Gunslinger_icon from "../../../assets/imgs/gunslinger.svg";
import Red_zone_threat_icon from "../../../assets/imgs/red-zone-threat.svg";
import Yac_monster_icon from "../../../assets/imgs/target_hog.svg";
import {
  convertInchesToFeet,
  getLabelAndScore,
  hapticsImpactLight,
} from "../../../lib/utils";
import PlayerScores from "../../PlayerProfile/PlayerScores/PlayerScores";
import ResearchOverview from "../../Research/ResearchOverview/ResearchOverview";
import ResearchStats from "../../Research/ResearchStats/ResearchStats";
import { Layout } from "../../Layouts/Layout";
import ArrowBackIcon from "../../../assets/imgs/arrow-back-left.svg";
import { Paragraph } from "../../Commons/Paragraph";
import LottieAnimation from "../../Commons/LottieAnimation/LottieAnimation";
import chatbotAnimation from "../../../assets/animations/Chatbot.json";
import eye_icon from "../../../assets/imgs/eye-white-icon.svg";
import PlayerScrollView from "../../PlayerProfile/PlayerScrollView/PlayerScrollView";
import PlayerLogo from "../../Commons/PlayersBgLogo/PlayersBgLogo";
import EyeIcon from "../../../assets/imgs//eye-white-icon.svg";
import PlayersTabs from "../../Commons/PlayerTabs/PlayerTabs";
import { AnimatePresence, motion } from "framer-motion";
import PlayerProfileDetails from "../../PlayerProfile/PlayerProfileDetails";
import ScoreModal from "../../ScoreModal/ScoreModal";
import PerfomanceModal from "../../PerfomanceModal/PerfomanceModal";
import playerProfileChat from "../../../assets/imgs/player_profile_chat.svg";
import { useMixpanel } from "../../../../src/Context/MixpanelContext/MixpanelProvider";
import { useSelector } from "react-redux";
import { actions } from "../../../../src/Redux/store";
import { PlayerProfilesById } from "../../../../src/Controllers/PlayerProfileByIdApi";
import IonicSelect from "../../Commons/IonicSelect/IonicSelect";
import { useSafeAreaInsets } from "../../../Context/SafeAreaContext/SafeAreaContext";
import PlayersProfileStatIcon from "../../../assets/imgs/players-profile-stat-icon.svg";
import PlayersProfileBackdropHeader from "../../../assets/imgs/Header-Backdrop-players.png";
import { SimilarPlayersTeamColor } from "../../../config/constants/teamColors";
import { getArchetypeIcon } from "../../../utils/getArchetypeIcon";

export default function PlayerProfile() {
  const { top, bottom, left, right } = useSafeAreaInsets();
  const platform = Capacitor.getPlatform();
  const navigate = useNavigate();
  const isOpen = useSelector(
    (sate: any) => sate.modal.playerProfileModal?.open,
  );
  const toggle = () => {
    actions.modal.closePlayerProfileModal(null);
  };
  const playerId = useSelector(
    (sate: any) => sate.modal.playerProfileModal?.data?.playerId,
  );
  const [player, setPlayer] = useState<any>();
  const [playerProfileLoading, setPlayerProfileLoading] = useState<boolean>(false);
  const [selected, setSelected] = useState<number | null>(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [expandedCardIndex, setExpandedCardIndex] = useState<number | null>(
    null,
  );
  const [useBadge, setUseBadge] = useState<boolean>(false);
  const [performanceScores, setPerformanceScores] = useState<any[]>([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [playersCard, setPlayersCard] = useState(playerDummies);
  const [playerDetails, setPlayerDetails] = useState<any>([]);
  const [scoreModal, setScoreModal] = useState(false);
  const { logEventAnalytics } = useFirebaseAnalytics();
  const Mixpanel = useMixpanel();
  const [togglePerfomanceModal, setTogglePerfomanceModal] = useState(false);
  const [selectedStat, setSelectedStat] = useState<any>(null);
  const [similarPlayerId, setSimilarPlayerId] = useState<string | null>(null);
  const contentRef = useRef<HTMLIonContentElement>(null);

  const scrollToTop = (duration = 500) => {
    if (!contentRef.current) return;
    
    // Using IonContent's scrollToTop method with animation duration
    contentRef.current.scrollToTop(duration);
  };

  const handleTabChange = (index: number) => {
    console.log(`Selected Tab: ${index}`);
    logEventAnalytics(tabs[index]?.eventName, {
      name: tabs[index]?.eventDesccription,
      playerID: playerId,
    });
    Mixpanel.trackEvent(tabs[index]?.eventName, {
      name: tabs[index]?.eventDesccription,
      playerID: playerId,
    });
    setSelectedTab(index);
  };
  useEffect(() => {
    const fetchPlayerData = async () => {
      try {
        setPlayerProfileLoading(true);
        setPlayer(null); // Clear previous player data first
        const idToFetch = similarPlayerId || playerId;
        scrollToTop();
        const response = await PlayerProfilesById(idToFetch as string);
        setPlayer(response?.data?.data?.data);
        Mixpanel.trackEvent("player_profile_modal_open_by_user", {
          name: "Player Profile modal open by user",
          player_name: response?.data?.data?.data?.playerName,
        });
      } catch (error) {
        console.error("Error fetching player data:", error);
      } finally {
        setPlayerProfileLoading(false);
      }
    };

    if (playerId || similarPlayerId) {
      fetchPlayerData();
    }
  }, [playerId, similarPlayerId]);

  const getBadgeIcon = (badgeType: string) => {
    switch (badgeType) {
      case "Game Manager":
        return Game_manager_icon;
      case "Goal Line Back":
        return Goal_line_back_icon;
      case "Receiving Back":
        return Receiving_back_icon;
      case "Scrambler":
        return Scrambler_icon;
      case "Target Hog":
        return Target_hog_icon;
      case "Work Horse":
        return Work_horse_icon;
      case "Gunslinger":
        return Gunslinger_icon;
      case "Red Zone Threat":
        return Red_zone_threat_icon;
      case "Yac Monster":
        return Yac_monster_icon;
      case "Rusher":
        return Scrambler_icon;
      case "Bell Cow":
        return Work_horse_icon;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (player) {
      const scores = [
        {
          score: player?.statDock
            ? parseFloat(
                Number(player?.statDock?.ADP_2025).toFixed(0),
              ).toString()
            : "--",
          label: "2025 ADP",
        },
        {
          score: player?.statDock?.FPPG_2024
            ? parseFloat(
                Number(player?.statDock?.FPPG_2024).toFixed(1),
              ).toString()
            : "--",
          label: "Avg FPPG",
        },
        {
          score: player?.statDock?.Archetype
            ? player?.statDock?.Archetype
            : "--",
          label: player?.statDock?.Archetype,
        },
      ];

      const badgeIcon = getBadgeIcon(
        player?.playerPerformanceScores?.playerValues?.playerBadgeType,
      );
      const badgeType =
        player?.playerPerformanceScores?.playerValues?.playerBadgeType;

      if (badgeType && badgeType !== "Null") {
        scores.splice(1, 0, {
          score: badgeIcon,
          label: badgeType,
        });
        setUseBadge(true);
      } else {
        setUseBadge(false);
      }

      setPerformanceScores(scores);
    }
  }, [player]);

  useEffect(() => {
    if (player) {
      const PlayerDetailsData = [
        {
          title: player?.playerPositionRank,
          subTitle: "Pos Rank",
        },
        {
          title: player?.playerOverallRank,
          subTitle: "Ovr. Rank",
        },
        {
          title: player?.playerAge,
          subTitle: "Age",
        },
        {
          title: `${player?.playerExperience}yr`,
          subTitle: "Experience",
        },
        {
          title: convertInchesToFeet(player?.playerHeight),
          subTitle: "Height",
        },
        {
          title: player?.playerWeight?.toString()?.replace("lbs", ""),
          subTitle: "Weight",
        },
        {
          title: parseFloat(
            Number(
              player?.playerPerformanceScores?.playerValues?.playerSeasonFP,
            ).toFixed(1),
          ).toString(),
          subTitle: "Avg. FP",
        },
        {
          title: parseFloat(
            Number(
              player?.playerPerformanceScores?.playerValues?.playerTradeValue,
            ).toFixed(1),
          ).toString(),
          subTitle: "Total FP",
        },
      ];
      setPlayerDetails(PlayerDetailsData);
    }
  }, [player]);

  const handleExpand = (index: number) => {
    if (expandedCardIndex === index) {
      setExpandedCardIndex(null);
    } else {
      setExpandedCardIndex(index);
    }
  };

  const handleCollapse = () => {
    setExpandedCardIndex(null);
  };

  const handlePerfomanceModal = () => {
    setTogglePerfomanceModal(true);
  };

  const tabs = [
    {
      label: "METRICS",
      content: (
        <PlayerScores
          setSimilarPlayerId={setSimilarPlayerId}
          showSimilarPlayers={true}
          player={player}
          handlePerfomanceModal={handlePerfomanceModal}
        />
      ),
      eventName: "player_profile_metrics_view",
      eventDesccription: "View player metrics",
    },
    {
      label: "LATEST NEWS",
      content: <ResearchOverview data={player} setSimilarPlayerId={setSimilarPlayerId} playerProfileLoading={playerProfileLoading}/>,
      eventName: "player_profile_news_view",
      eventDescription: "View player news",
    },
    {
      label: "GAME LOG",
      content: (
        <div className="-mx-5">
          <ResearchStats
            statsData={player?.statsSummary}
            weeklyStats={player?.gameLogs}
            playerPosition={player?.playerPosition}
          />
        </div>
      ),
      eventName: "player_profile_log_view",
      eventDescription: "View player game log",
    },
  ];

  const handleChatbotByPlayerProfile = () => {
    navigate(`/chatbot-ai`);

    // logEventAnalytics("open_player_analyzer_chat", { playerID: playerId });
    // if (route === "ranking") {
    //   navigate(`/player/${playerId}/chat/new?route=${route}`);
    // } else {
    //   navigate(`/player/${playerId}/chat/new`);
    // }
  };

  // const goBack = () => {
  //   hapticsImpactLight();
  //   if (route === "ranking") {
  //     navigate(
  //       `/rankings?route=${route} ${PosId && PerId ? `&pos=${PosId}&per=${PerId}` : ""} `,
  //     );
  //   } else {
  //     navigate(`/home`);
  //   }
  // };

  function dismiss() {
    setSimilarPlayerId(null);
    setPlayer(null);
    modalProfile.current?.dismiss();
    toggle();
  }

  const closeProfileModal = () => {
    setSimilarPlayerId(null);
    setPlayer(null);
    actions.modal.closePlayerProfileModal(null);
    modalProfile.current?.dismiss();
  };

  const modalProfile = useRef<HTMLIonModalElement>(null);

  return (
    <IonModal
      expandToScroll={false}
      onDidDismiss={dismiss}
      isOpen={isOpen}
      backdropDismiss={false}
      initialBreakpoint={0.95}
      breakpoints={[0, 0.95]}
      className={`${platform === "web" ? "full-modal" : "profile-modal"} `}
      ref={modalProfile}
    >
      <IonContent
        ref={contentRef}
        scrollEvents={true}
        fullscreen={true}
        forceOverscroll={false}
        scrollY={true}
      >
        <div
          className="flex flex-col h-full rounded-t-[50px]"
          style={{
            paddingTop: 0,
            paddingBottom: bottom,
            paddingLeft: left,
            paddingRight: right,
          }}
        >
          <div className="flex-1 no-scrollbar p-5">
            <div className="-mt-5 pt-5 -mx-5 px-5 transition-all duration-500 relative">
              {SimilarPlayersTeamColor[player?.playerTeamShort] && (
                <div
                  className="absolute inset-0 w-full h-full"
                  style={{
                    background: `url(${PlayersProfileBackdropHeader}), #000513`,
                    filter: "blur(31.5px)",
                  }}
                ></div>
              )}
              <div
                className="absolute inset-0 w-full h-full"
                style={{
                  backgroundColor:
                    `${SimilarPlayersTeamColor[player?.playerTeamShort]}` ||
                    "#091125",
                  opacity: "0.3",
                }}
              ></div>
              <div className=" flex justify-between items-center py-4 relative z-20">
                <div onClick={closeProfileModal} className="cursor-pointer p-2">
                  <img
                    src={closeIcon}
                    alt="close"
                    className="w-[15px] h-[15px] "
                  />
                </div>

                <div className="text-[22px] md:text-[22px] font-medium text-white">
                  Player Profile
                </div>

                <div
                  onClick={handleChatbotByPlayerProfile}
                  className="cursor-pointer"
                >
                  <img src={playerProfileChat} alt="playerProfileChat" />
                </div>
              </div>
              {/* <div className="flex items-center justify-between relative z-10">
            <div
              className="cursor-pointer rounded-full w-[58px] h-[58px] flex justify-center items-center grayBtn"
              onClick={goBack}
            >
              <img src={ArrowBackIcon} alt="Back" />
            </div>
            <Paragraph
              text="Player Profile"
              ParagraphType="Paragraph22"
              color="textPrimary"
              className="text-[22px] md:text-2xl lg:text-[34.091px] font-bold leading-[100%]"
            />
            <div
              className="cursor-pointer flex justify-center items-center"
              onClick={handleChatbotByPlayerProfile}
            >
              <div className=" rounded-full w-[58px] h-[58px] sm:hidden">
                <LottieAnimation animationData={chatbotAnimation} />
              </div>
              <div
                className="rounded-full w-auto h-[58px] sm:flex items-center gap-2 px-4 hidden"
                style={{
                  background:
                    "linear-gradient(to top right, #602087 9.42%, #3133CF 51%, #2DA1F9 88.63%)",
                }}
              >
                <img
                  src={eye_icon}
                  className="lg:w-[40.813px] md:w-[38.813px] sm:w-8"
                  alt=""
                />
                <Paragraph
                  text={`Ask About ${player?.playerFirstName.split(" ")[0]}`}
                  className="text-sm md:text-lg lg:text-xl !font-medium"
                  ParagraphType="Pragragh22"
                  color="textPrimary"
                />
              </div>
            </div>
          </div> */}
              <div className="relative">
                <div
                  className={`flex justify-between mt-3 relative items-end ${expandedCardIndex !== null && "-z-10"}`}
                >
                  <PlayerScrollView
                    setScrollPosition={setScrollPosition}
                    scrollPosition={scrollPosition}
                    player={player}
                  />
                  {/* <div
                className="absolute -top-10 opacity-10 w-full h-full sm:hidden"
                style={{
                  backgroundImage: `url(${player?.playerTeamImageURL})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  opacity: playerId === "breehall1" ? 0.4 : 0.1,
                }}
              ></div> */}
                  <PlayerLogo
                    player={player}
                    playerId={playerId ? playerId : ""}
                  />
                </div>
                <div className="absolute top-0 hidden sm:block sm:-top-[110px] lg:-top-[140px] sm:-left-[200px] lg:min-h-[603px] md:min-h-[475px] opacity-1 w-full h-full">
                  <img
                    src={player?.playerTeamImageURL}
                    alt="player?.playerTeamImageURL"
                    className="w-full h-[96.8%] object-cover"
                  />
                </div>
              </div>
            </div>


            {/* Player Profile Stats */}
            {/* <div className="flex justify-between w-full mt-2">
              <Paragraph
                text={"Stats"}
                className="text-base font-semibold mt-1.5"
                ParagraphType="Paragraph22"
                color="textPrimary"
              />
            </div>
            <div className="py-6 px-4 -mx-5 flex gap-4 overflow-x-auto no-scrollbar">
              <div className="grid grid-cols-3 sm:hidden gap-[10px] w-full">
                {performanceScores.length > 0 &&
                  performanceScores.map((score, index) => (
                    <div
                      className="flex justify-center"
                      key={index}
                      onClick={() => index == 0 && setScoreModal(true)}
                    >
                      <div
                        className={`text-center w-full h-[63px] flex justify-between flex-col p-[10px] rounded-xl cursor-pointer relative bg-[${Colors.backgroundSecundary}]`}
                      >
                        <div className="flex gap-1">
                          <Paragraph
                            text={score.label}
                            props={{
                              fontSize: "9.6px",
                              color: Colors.textLigth,
                              lineHeight: "100%",
                              marginTop: selected !== index ? "10px" : "",
                            }}
                            ParagraphType="Paragraph22"
                            color="textPrimary"
                            className="!mt-0"
                          />
                          {selected === index && (
                            <img
                              className="h-[12px]"
                              src={EyeIcon}
                              alt={"EyeIcon"}
                            />
                          )}
                        </div>
                        {index === 1 && useBadge ? (
                          score.score !== null ? (
                            <img
                              className="h-[19.26px]"
                              src={score.score}
                              alt={score.label}
                            />
                          ) : (
                            <Paragraph
                              text={"--"}
                              props={{
                                fontSize: "21.97px",
                                fontWeight: 300,
                                lineHeight: "100%",
                              }}
                              ParagraphType="Paragraph22"
                              color="textPrimary"
                            />
                          )
                        ) : (
                          <div className="flex items-end gap-1">
                            {index === performanceScores.length - 1 ? (
                              getArchetypeIcon({ archetype: score.score })
                            ) : (
                              <Paragraph
                                text={score.score}
                                props={{
                                  fontSize: "17px",
                                  fontWeight: index === 0 ? 500 : 300,
                                  lineHeight: "100%",
                                }}
                                ParagraphType="Paragraph22"
                                color="textPrimary"
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
              <div className="sm:flex hidden">
                {playerDetails.length > 0 &&
                  playerDetails.map((item: any, index: number) => {
                    return (
                      <div className="flex-shrink-0 flex gap-4" key={index}>
                        <div
                          className={`text-center w-[115.2px] h-[101px] flex items-center justify-center flex-col p-[10px] rounded-xl cursor-pointer ${
                            0 === index
                              ? `bg-[${Colors.backgroundSecundary}]`
                              : ""
                          }`}
                        >
                          <Paragraph
                            text={item.title}
                            props={{
                              fontSize: "34px",
                              fontWeight: 600,
                              lineHeight: "100%",
                            }}
                            ParagraphType="Paragraph22"
                            color="textPrimary"
                          />
                          <div className="flex items-center gap-1">
                            <Paragraph
                              text={item.subTitle}
                              props={{
                                fontSize: "9.6px",
                                color: Colors.textLigth,
                                lineHeight: "100%",
                                marginTop: "10px",
                              }}
                              ParagraphType="Paragraph22"
                              color="textPrimary"
                            />
                          </div>
                        </div>
                        <div
                          className={`h-12 w-px bg-[${Colors.backgroundSecundary}] my-auto`}
                        ></div>
                      </div>
                    );
                  })}
              </div>
            </div> */}

            <div className="mt-5">
              <PlayersTabs tabs={tabs} onTabChange={handleTabChange} />
            </div>

            <div className="pb-5" />
            <AnimatePresence>
              {expandedCardIndex !== null && (
                <motion.div
                  className="w-full"
                  initial={{
                    opacity: 0,
                  }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                  <PlayerProfileDetails
                    item={
                      player?.playerPerformanceScores?.performanceCards[
                        expandedCardIndex
                      ]
                    }
                    onClose={handleCollapse}
                  />
                </motion.div>
              )}
            </AnimatePresence>
            <ScoreModal
              isVisible={scoreModal}
              onClose={() => setScoreModal(false)}
            />

            <PerfomanceModal
              isVisible={togglePerfomanceModal}
              onClose={() => setTogglePerfomanceModal(false)}
            />
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
}
